export const name = 'customUrlMapper' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const CustomUrlMapperSymbol = Symbol('CustomUrlMapper')
